jQuery(document).ready(function($){
    $('.image-gallery').lightSlider({ 
    gallery:false, 
    item:1, //number of slides to show at a time
    mode: "fade",
    useCSS: true,
    cssEasing: 'ease', //'cubic-bezier(0.25, 0, 0.25, 1)',//
    pause: 4000,
    speed: 1000, //ms'
    auto:true, 
    loop:true,
    slideEndAnimation: true, 
    thumbItem: 9,
    item:1,
    adaptiveHeight:false,
    pauseOnHover: true,
    slideMargin: 0,
    autoWidth: true,
    controls: false,
    pager:false
    });
    });

    // jQuery(document).ready(function($) {
    //     // Close modal 
    //     $('.close-modal').click(function() {
    //       $('.modal').toggleClass('show');
    //     });
      
    //     // Detect windows width function
    //     var $window = $(window);
      
    //     function checkWidth() {
    //       var windowsize = $window.width();
    //       if (windowsize > 767) {
    //         // if the window is greater than 767px wide then do below. we don't want the modal to show on mobile devices and instead the link will be followed.
      
    //         $(".modal-link").click(function(e) {
    //           var modalContent = $("#modal-content");
    //           var post_link = $('.show-in-modal').html(); // get content to show in modal
    //           //var post_link = $(this).attr("href"); // this can be used in WordPress and it will pull the content of the page in the href
              
    //           e.preventDefault(); // prevent link from being followed
              
    //           $('.modal').addClass('show', 1000, "easeOutSine"); // show class to display the previously hidden modal
    //           modalContent.html("loading..."); // display loading animation or in this case static content
    //           modalContent.html(post_link); // for dynamic content, change this to use the load() function instead of html() -- like this: modalContent.load(post_link + ' #modal-ready')
    //           $("html, body").animate({ // if you're below the fold this will animate and scroll to the modal
    //             scrollTop: 0
    //           }, "slow");
    //           return false;
    //         });
    //       }
    //     };
      
    //     checkWidth(); // excute function to check width on load
    //     $(window).resize(checkWidth); // execute function to check width on resize
    //   });

      // Smooth Scroll from slider to Nav
      jQuery("#arrow").click(function() {
        $('html, body').animate({
            scrollTop: $("#main-nav").offset().top
        }, 1000);
    });



/*------------------------------------------------------------------------------------------------------------------------------
*
* Reveal Mobile Menu dropdown
*
*/

jQuery(document).ready(function($) {
$("#mobile-menu").click(function(){
  $("#main-menu").slideToggle();
});
});



// new ModalVideo('.js-modal-btn', {channel: 'vimeo'});
jQuery(document).ready(function($) {

$(".js-video-button").modalVideo({
  channel: 'vimeo',
  vimeo: {
    api: false,
    autopause: true,
    autoplay: true,
    byline: true,
    callback: null,
    color: 'red',
    height: null,
    loop: true,
    maxheight: null,
    maxwidth: null,
    muted: false,
    player_id: null,
    portrait: true,
    title: true,
    width: 2000,
    xhtml: false
  },
  ratio: '16:9',
  allowFullScreen: true,
  animationSpeed: 300,
  classNames: {
    modalVideo: 'modal-video',
    modalVideoClose: 'modal-video-close',
    modalVideoBody: 'modal-video-body',
    modalVideoInner: 'modal-video-inner',
    modalVideoIframeWrap: 'modal-video-movie-wrap',
    modalVideoCloseBtn: 'modal-video-close-btn'
  },
  aria: {
    openMessage: 'You just openned the modal video',
    dismissBtnMessage: 'Close the modal by clicking here'
  }
});



});